import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSButton } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { useParams } from "react-router-dom";
import ChatContent from "../components/ChatContent";
import ChatSidebar from "../components/ChatSidebar";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from "../InferenceLayout";
import { InferenceRouterProps } from "../InferenceRouterProps";
import { InferenceChatTargetType, InferenceRoutes } from "../InferenceRoutes";
import Styles from "./ChatPage.module.css";

interface ChatPageInnerProps extends NSARouterMakerResult, InferenceRouterProps
{
    target_type: InferenceChatTargetType;
    target_id: string;
    chat_id: string;
}

export class ChatPageInner extends Component<ChatPageInnerProps>
{
    private ChatSidebar_Ref = createRef<ChatSidebar>();

    override render()
    {
        return (
            <InferenceLayout {...this.props} action={{ description: InferenceInfo.chat_live }}>
                <section className={Styles.ns_chat_page}>
                    <NSButton
                        onClick={{
                            showLoading: false,
                            action: () => this.ChatSidebar_Ref.current?.setOpen(true),
                        }}
                        classList={[Styles.ns_chat_btn]}
                        icon={{ src: "https://static.namirasoft.com/image/concept/menu/burger-blue.svg", alt: "Open Menu" }}
                    />

                    <ChatSidebar
                        {...this.props}
                        ref={this.ChatSidebar_Ref}
                        target_type={this.props.target_type}
                        target_id={this.props.target_id}
                        chat_id={this.props.chat_id}
                        onNewChat={() => this.props.url.redirect(InferenceRoutes.ChatNew(this.props.target_type, this.props.target_id), {})}
                        onSelect={(chat) => this.props.url.redirect(InferenceRoutes.Chat(this.props.target_type, this.props.target_id, chat.id), {})}
                    />

                    <ChatContent
                        {...this.props}
                        chat_id={this.props.chat_id}
                        target_type={this.props.target_type}
                        target_id={this.props.target_id}
                        onNewChat={(chat_id) => this.props.url.redirect(InferenceRoutes.Chat(this.props.target_type, this.props.target_id, chat_id), {})}
                    />
                </section>
            </InferenceLayout>
        );
    }
}

interface ChatPageProps extends NSARouterMakerResult, InferenceRouterProps
{
    target_type: InferenceChatTargetType;
}

function ChatPage(props: ChatPageProps)
{
    let params = useParams();
    let target_id = params["target_id"] ?? "";
    let chat_id = params["chat_id"] ?? "";
    if (chat_id === "new")
        chat_id = "";
    return <ChatPageInner {...props} target_id={target_id} chat_id={chat_id} />;
}

export default ChatPage;